import React from "react";
import Icon from "../../../components/AppIcon";

const ORANGE = "#F27E33";
const NAVY = "#1D2946";

export default function ContactMap() {
  // Coordenadas Bogotá centro
  const lat = 4.7110;
  const lng = -74.0721;
  const zoom = 15;
  const mapSrc = `https://www.google.com/maps?q=${lat},${lng}&z=${zoom}&hl=es&output=embed`;

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-20">
      <div
        className="relative rounded-2xl p-[2px]"
        style={{
          background:
            "linear-gradient(135deg, rgba(255,255,255,.28) 0%, rgba(255,255,255,.10) 100%)",
        }}
      >
        <div
          className="rounded-2xl overflow-hidden"
          style={{
            background: "rgba(255,255,255,.06)",
            border: "1px solid rgba(255,255,255,.15)",
            backdropFilter: "blur(6px)",
          }}
        >
          {/* Header */}
          <div
            className="px-5 py-4"
            style={{
              background: `linear-gradient(90deg, ${NAVY} 0%, ${ORANGE} 100%)`,
            }}
          >
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-white/15 flex items-center justify-center">
                <Icon name="MapPin" size={18} className="text-white" />
              </div>
              <div>
                <h3 className="font-orbitron text-white text-lg">
                  Encuéntranos aquí
                </h3>
                <p className="font-body text-white/85 text-xs">
                  Oficina Principal — Bogotá D.C.
                </p>
              </div>
            </div>
          </div>

          {/* Mapa */}
          <div className="px-5 pb-5">
            <div
              className="relative rounded-2xl p-4"
              style={{
                background: "rgba(255,255,255,.06)",
                border: "1px solid rgba(255,255,255,.15)",
                boxShadow: `inset 0 0 60px ${ORANGE}22`,
              }}
            >
              <div
                className="absolute -top-[1px] left-0 h-1 w-44 rounded-tr"
                style={{
                  background: `linear-gradient(90deg, ${ORANGE}, ${NAVY})`,
                }}
              />

              <div className="aspect-[16/6] w-full rounded-xl overflow-hidden">
                <iframe
                  title="Sede SIRECC Bogotá"
                  src={mapSrc}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-full border-0"
                />
              </div>
            </div>

            {/* Info de contacto */}
            <div
              className="mt-6 rounded-xl px-6 py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4"
              style={{
                background: "rgba(255,255,255,.06)",
                border: "1px solid rgba(255,255,255,.12)",
              }}
            >
              <div className="text-white/85 font-body text-sm space-y-1">
                <p>
                  <Icon name="MapPin" size={14} className="inline mr-2" />
                  Calle 106 # 51 - 02 Oficina 503, Bogotá D.C.
                </p>
                <p>
                  <Icon name="Phone" size={14} className="inline mr-2" />
                  (+57) 322 510 7655 · (+57) 311 220 2274
                </p>
                <p>
                  <Icon name="Mail" size={14} className="inline mr-2" />
                  Sirecc.sas@gmail.com
                </p>
              </div>

              <a
                href="tel:+573225107655"
                className="inline-flex items-center gap-2 rounded-xl border px-5 py-2 font-orbitron transition bg-white text-sm"
                style={{ color: NAVY, borderColor: "rgba(0,0,0,.06)" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow = `0 0 0 3px ${ORANGE}44`)
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <Icon name="PhoneCall" size={16} />
                Llamar
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
